import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="results-title" data-id="element-148" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-149" data-mp="28ddhzave4dr9">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-150" data-mp="2d6zw77h7cpp6">
          What educators using this teacher ready say
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-151" data-mp="2m6cvx8fixzwp">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-line bg-white p-6 shadow-card ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-152" data-mp="2r6r7h0gc3rzh" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-leaf" aria-hidden="true" data-id="element-153" data-mp="3neqyr6oaedt8" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-154" data-mp="3ilxtmhowp3gm">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-line pt-4" data-id="element-155" data-mp="3do623os6bjcy">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-navy text-sm font-extrabold text-white" data-id="element-156" data-mp="38pusnf5sjav9">
                  {initials}
                </span>
                <span data-id="element-157" data-mp="58uqeuykluff">
                  <b className="block text-sm text-navy" data-id="element-158" data-mp="58copit52o04">{name}</b>
                  <small className="text-xs text-muted" data-id="element-159" data-mp="7ynajm1mcb2">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}